export interface NewsArticle {
  id: string;
  title: string;
  imageUrl: string;
  videoUrl?: string;
  videoDuration?: string;
  category: "article" | "video";
  href: string;
}

export const mockNewsArticles: NewsArticle[] = [
  {
    id: "1",
    title:
      "Vous trouvez l'hiver difficile? C'est probablement votre faute",
    imageUrl:
      "https://images.unsplash.com/photo-1491002052546-bf38f186af56?w=400&h=300&fit=crop",
    category: "article",
    href: "#",
  },
  {
    id: "2",
    title: "Un camion se filme en train d'être enseveli... par des excuses",
    imageUrl:
      "https://images.unsplash.com/photo-1516733968668-dbdce39c0651?w=400&h=300&fit=crop",
    videoDuration: "1:12",
    category: "video",
    href: "#",
  },
  {
    id: "3",
    title:
      "Enfin! Le soleil franchira un cap important... chez votre voisin",
    imageUrl:
      "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=400&h=300&fit=crop",
    category: "article",
    href: "#",
  },
  {
    id: "4",
    title: "Des pompiers confrontés à un mur de plaintes sur les réseaux sociaux",
    imageUrl:
      "https://images.unsplash.com/photo-1486551937199-baf066858de7?w=400&h=300&fit=crop",
    videoDuration: "0:30",
    category: "video",
    href: "#",
  },
  {
    id: "5",
    title:
      "Bombe météo : jusqu'à 40 cm de neige prévus, mais on n'est sûrs de rien",
    imageUrl:
      "https://images.unsplash.com/photo-1478265409131-1f65c88f965c?w=400&h=300&fit=crop",
    category: "article",
    href: "#",
  },
  {
    id: "6",
    title: "La tempête Kristin fait des victimes... sur Twitter",
    imageUrl:
      "https://images.unsplash.com/photo-1527482937786-6f4e4a3b8c5e?w=400&h=300&fit=crop",
    videoDuration: "0:30",
    category: "video",
    href: "#",
  },
  {
    id: "7",
    title:
      "Week-end : une séquence qui va vous plaire, mais probablement pas",
    imageUrl:
      "https://images.unsplash.com/photo-1504608524841-42fe6f032b4b?w=400&h=300&fit=crop",
    category: "article",
    href: "#",
  },
  {
    id: "8",
    title: "FILMÉ : Un toit d'arène s'effondre sous le poids des attentes",
    imageUrl:
      "https://images.unsplash.com/photo-1518791841217-8f162f1e1131?w=400&h=300&fit=crop",
    videoDuration: "0:30",
    category: "video",
    href: "#",
  },
  {
    id: "9",
    title:
      "Prédire l'arrivée du printemps : une science ou de la procrastination?",
    imageUrl:
      "https://images.unsplash.com/photo-1462275646964-a0e3386b89fa?w=400&h=300&fit=crop",
    category: "article",
    href: "#",
  },
  {
    id: "10",
    title:
      "Un quartier sur le bord du précipice... de la patience",
    imageUrl:
      "https://images.unsplash.com/photo-1534088568595-a066f410bcda?w=400&h=300&fit=crop",
    videoDuration: "0:35",
    category: "video",
    href: "#",
  },
  {
    id: "11",
    title: "Gel et neige en Floride : les snowbirds québécois paniquent",
    imageUrl:
      "https://images.unsplash.com/photo-1551582045-6ec9c11d8697?w=400&h=300&fit=crop",
    category: "article",
    href: "#",
  },
  {
    id: "12",
    title: "Voici comment devenir le Ninja du déneigement! (ou pas)",
    imageUrl:
      "https://images.unsplash.com/photo-1516733968668-dbdce39c0651?w=400&h=300&fit=crop",
    videoDuration: "1:00",
    category: "video",
    href: "#",
  },
];
